export default "__VITE_ASSET__nlstnrYF__"